import { request } from '@/helpers';
import { ProductCategoryKindType } from '@/models';
import { EnvironmentFilters } from 'src/logic/models/catalogue/AdvancedFilters';
import Category from 'src/logic/models/catalogue/Category';
import { GroupIndex } from 'src/logic/models/catalogue/Group';
import { PaginatedResponse } from 'src/logic/models/queries';
import { CatalougeFilterItem } from '../products';

export const getGroups = ({
  environmentFilters = {},
  filters,
}: {
  environmentFilters: EnvironmentFilters;
  filters?: CatalougeFilterItem[];
}): Promise<{ data: GroupIndex }> => {
  return request({
    method: 'POST',
    url: `/product/catalog/products_services_tab`,
    data: {
      filters,
      ...environmentFilters,
    },
  });
};

export const getLandingPageGroups = (): Promise<{ data: GroupIndex }> => {
  return request({
    method: 'POST',
    url: `/product/catalog/products_services_tab`,
    data: {
      filters: [],
    },
    disableErrorMessage: true,
  });
};

export type TreeCategoryResponse = {
  categories: null | PaginatedResponse<Category>;
  classes: null | PaginatedResponse<Category>;
  types: null | PaginatedResponse<Category>;
};

export const getTreeCategories = (
  parent_id: number,
  environmentFilters: EnvironmentFilters = {},
  filters?: CatalougeFilterItem[],
  category_kind?: ProductCategoryKindType
): Promise<{
  data: {
    data: TreeCategoryResponse;
  };
}> => {
  return request({
    url: '/getTreeCategories',
    method: 'POST',
    data: {
      parent_id,
      filters,
      category_kind,
      ...environmentFilters,
    },
  });
};

export const getChildrenCategories = (
  parent_id: number,
  page: number,
  environmentFilters: EnvironmentFilters = {},
  filters?: CatalougeFilterItem[]
): Promise<{
  data: PaginatedResponse<Category>;
}> => {
  return request({
    url: `/getCategories`,
    method: 'POST',
    data: {
      parent_id,
      page,
      filters,
      ...environmentFilters,
    },
  });
};

export const getCategories = ({
  page,
  search,
  environmentFilters = {},
  filters,
}: {
  page: number;
  search?: string;
  environmentFilters: EnvironmentFilters;
  filters?: CatalougeFilterItem[];
}): Promise<{
  data: PaginatedResponse<Category>;
}> => {
  return request({
    url: `/getCategories`,
    method: 'POST',
    data: {
      page,
      category_type: 1,
      query: search,
      filters,
      ...environmentFilters,
    },
  });
};

export const getClasses = ({
  page,
  search,
  environmentFilters = {},
  filters,
}: {
  page: number;
  search?: string;
  environmentFilters: EnvironmentFilters;
  filters?: CatalougeFilterItem[];
}): Promise<{
  data: PaginatedResponse<Category>;
}> => {
  return request({
    url: `/getCategories`,
    method: 'POST',
    data: {
      page,
      category_type: 2,
      query: search,
      filters,
      ...environmentFilters,
    },
  });
};

export const getTypes = ({
  page,
  search,
  environmentFilters = {},
  filters,
}: {
  page: number;
  search?: string;
  environmentFilters: EnvironmentFilters;
  filters?: CatalougeFilterItem[];
}): Promise<{
  data: PaginatedResponse<Category>;
}> => {
  return request({
    url: `/getCategories`,
    method: 'POST',
    data: {
      page,
      category_type: 3,
      query: search,
      filters,
      ...environmentFilters,
    },
  });
};

export const getSellerCategories = ({
  seller_id,
  page,
  filtration_purpose,
}: {
  seller_id: number;
  page: number;
  filtration_purpose?: EnvironmentFilters['filtration_purpose'];
}) => {
  return request({
    url: `/getCategories`,
    method: 'POST',
    data: {
      page,
      category_type: 1,
      filters: [{ type: 'SELLER', ids: [seller_id] }],
      filtration_purpose,
    },
  });
};

export const getCategoryBySlug = (slug: string): Promise<{ data: Category }> => {
  return request({ url: `/product/categories/${slug}`, method: 'GET' });
};

export const getBuyerPurchasedCategories = ({ buyer_id, page }: { buyer_id: number; page: number }) => {
  return request({
    url: `/purchased-categories`,
    method: 'POST',
    data: {
      page,
      buyer_company_id: buyer_id,
    },
  });
};
